import { State } from '../reducers/rootReducer'
import VinStatus from '../../entities/VinStatus'

const vinStatusDataSelector = (state: State): VinStatus => state.vinStatusData

export default vinStatusDataSelector
